// extracted by mini-css-extract-plugin
module.exports = {"site_page_header_ghost_wrapper":"Header_site_page_header_ghost_wrapper__1L8Ko","title":"Header_title__3SH2Q"};